import React, { useEffect, useState } from "react";
import { Form } from "informed";
import { useCreateAccount } from "../../../peregrine/talons/CreateAccount/useCreateAccount";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import Button from "../Button";
import Field from "../Field";
import defaultClasses from "./createAccount.module.scss";
import FormError from "@overrides_venia/venia-ui/components/FormError";
import Password from "../Password";
import Checkbox from "../Checkbox";
import UIkit from "uikit";
import LoadingIndicator from "../LoadingIndicator";
import { useIntl } from "react-intl";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { SimpleField } from "@Components/FormFields/SimpleField";
import DobField from "@Components/FormFields/DobField";
import { GenderField } from "@Components/FormFields/GenderField";
import { handleDisabledButtonClick, isEmailValid, isPasswordValid, isTelephoneNumberValid } from "@Src_main/utils/generalUtils";
import { isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
import { useAppContext } from "@overrides_venia/peregrine/context/app";
var CreateAccountFormComplete = props => {
  var {
    formatMessage
  } = useIntl();
  var {
    isMobile
  } = useWindowSize();
  var [{
    footer_nav
  }] = useAppContext();
  var handleSubmitAfterSuccess = () => {
    try {
      UIkit.offcanvas("#offcanvas-registration-dx").hide();
    } catch (error) {
      console.error(error);
    }
  };
  var talonProps = useCreateAccount({
    initialValues: props.initialValues,
    onSubmit: handleSubmitAfterSuccess,
    onCancel: props.onCancel
  });
  var {
    errors,
    handleSubmit,
    initialValues,
    loading
  } = talonProps;
  var [buttonEnable, setbuttonEnable] = useState(false);
  var [isPassOk, setPasswordValid] = useState(false);
  var [isEmailOk, setEmailValid] = useState(false);
  var [isLoyaltyOk, setIsLoyaltyValid] = useState(false);
  var [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(0);
  var classes = mergeClasses(defaultClasses, props.classes);
  var [dobValue, setDobValue] = useState("");
  var handleChange = event => {
    var loyaltyChecked = event.values.loyalty ? true : false;
    var emailValid = event.values.email && isEmailValid(event.values.email);
    var passwordValid = event.values.password && isPasswordValid(event.values.password);
    var nameValid = event.values.firstname ? true : false;
    var dobValid = dobValue ? true : false;
    var genderValid = event.values.gender ? true : false;
    var telephoneValid = isTelephoneNumberValid(event.values.telephone);
    if (loyaltyChecked) setIsLoyaltyValid(true);else setIsLoyaltyValid(false);
    if (passwordValid) setPasswordValid(true);else setPasswordValid(false);
    if (emailValid) setEmailValid(true);else setEmailValid(false);
    if (emailValid && passwordValid && loyaltyChecked && nameValid) setbuttonEnable(true);else setbuttonEnable(false);
  };
  var infoPassword = /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-margin-small-bottom uk-margin-small-top ".concat(classes.infobox)
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-emphasis"
  }, formatMessage({
    id: "registration.modal.info.pass"
  })));
  var passwordCorretta = /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-margin-small-bottom uk-margin-small-top ".concat(classes.infobox, " ").concat(classes.infoboxSuccess)
  }, /*#__PURE__*/React.createElement("div", null, formatMessage({
    id: "registration.modal.pass.ok"
  })));
  var feedbackPassword = isPassOk ? passwordCorretta : infoPassword;
  var submitButton = /*#__PURE__*/React.createElement("div", {
    className: " uk-container button-container_registration ".concat(classes.actions)
  }, /*#__PURE__*/React.createElement(Button, {
    id: "headerCreateAccount",
    disabled: !buttonEnable && hasAttemptedSubmit,
    color: "primary",
    fullScreen: !isMobile,
    type: "submit",
    priority: "high",
    onClick: () => {
      setHasAttemptedSubmit(hasAttemptedSubmit + 1);
    }
  }, formatMessage({
    id: "button.registration"
  })));
  useEffect(() => {
    if (!buttonEnable) {
      handleDisabledButtonClick();
    }
  }, [hasAttemptedSubmit]);
  return loading ? /*#__PURE__*/React.createElement(LoadingIndicator, {
    global: false
  }) : /*#__PURE__*/React.createElement(Form, {
    className: "form-container_registration uk-flex uk-flex-column",
    initialValues: initialValues,
    onSubmit: values => handleSubmit(values, dobValue),
    onChange: handleChange,
    id: "form-create-account",
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement(FormError, {
    errors: Array.from(errors.values()),
    id: "create-account"
  }), /*#__PURE__*/React.createElement(SimpleField, {
    id: "emailField",
    label: "input.email",
    type: "email",
    name: "email",
    invalid: !isEmailOk && hasAttemptedSubmit,
    showInvalid: hasAttemptedSubmit
  }), /*#__PURE__*/React.createElement(Password, {
    fieldName: "password",
    isToggleButtonHidden: false,
    label: "input.password",
    id: "passwordRegistration",
    invalid: !isPassOk && hasAttemptedSubmit,
    showInvalid: hasAttemptedSubmit
  }), feedbackPassword, /*#__PURE__*/React.createElement(SimpleField, {
    label: "input.name",
    topLabelOverride: "input.section.name",
    showLabel: true,
    name: "firstname",
    required: true,
    showInvalid: hasAttemptedSubmit
  }), /*#__PURE__*/React.createElement(DobField, {
    value: dobValue,
    setValue: setDobValue,
    required: false,
    showInvalid: hasAttemptedSubmit
  }), /*#__PURE__*/React.createElement(SimpleField, {
    label: "input.phone.number",
    name: "telephone",
    type: "tel",
    note: formatMessage({
      id: "note.phone.field"
    }),
    required: false,
    showInvalid: hasAttemptedSubmit
  }), /*#__PURE__*/React.createElement(GenderField, {
    showLabel: true,
    required: false,
    showInvalid: hasAttemptedSubmit
  }), /*#__PURE__*/React.createElement("div", {
    className: "privacy-container ".concat(isMobile ? "uk-margin-bottom" : "")
  }, /*#__PURE__*/React.createElement(Field, null, /*#__PURE__*/React.createElement(Checkbox, {
    field: "loyalty",
    name: "loyalty-account",
    label_normal: formatMessage({
      id: "registration.modal.loyalty.policy"
    }),
    rootClassName: isLoyaltyOk ? "" : "shake-incomplete"
  })), /*#__PURE__*/React.createElement(Field, null, /*#__PURE__*/React.createElement(Checkbox, {
    field: "profiling",
    name: "profiling-account",
    label_normal: formatMessage({
      id: "registration.modal.loyalty.profiling"
    }),
    show_more: formatMessage({
      id: "registration.modal.loyalty.profiling.more.info"
    }),
    label_extended: formatMessage({
      id: "registration.modal.loyalty.profiling.info"
    })
  }))), submitButton);
};
export default CreateAccountFormComplete;